import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/app/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/swiper/swiper.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/swiper/modules/navigation.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/swiper/modules/pagination.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-toastify/dist/ReactToastify.css");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/award1.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/award2.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/award3.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/award4.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/ecg.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/electrocardiogram.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/mammography.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/PFT.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/TMT.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/ultrasound.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/xray.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/ClientErrorReporter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/Footer.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/common/Footer/CityAwareLinkList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/Footer/HealthScansAndImagingTestSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/Footer/PopularTestLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/Footer/TestsInOtherCitiesLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/FooterVisibility.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/GetAFreeCallBack.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/InlineLinkList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/Modal/ModalsContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/SessionReconciler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/SharedCatalogHydrator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/src/lib/Provider.tsx");
